import { ChangeDetectorRef, inject, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { filter, merge, Subscription } from 'rxjs';

/**
 * Translates a navigation title/subtitle through the `nav.<title>` key, keeping the
 * original text when no translation exists (e.g. titles sent by the backend).
 * Re-renders OnPush hosts when the active language changes.
 */
@Pipe({ name: 'navTitle', pure: false })
export class NavTitlePipe implements PipeTransform, OnDestroy {
    private _transloco = inject(TranslocoService);
    private _cdr = inject(ChangeDetectorRef);
    // The language file may finish loading after the language switch, so refresh on both
    private _sub: Subscription = merge(
        this._transloco.langChanges$,
        this._transloco.events$.pipe(filter(e => e.type === 'translationLoadSuccess')),
    ).subscribe(() => this._cdr.markForCheck());

    transform(title: string): string {
        if (!title) {
            return title;
        }
        const key = `nav.${title}`;
        return this._transloco.translate(key) === key ? title : this._transloco.translate(key);
    }

    ngOnDestroy(): void {
        this._sub.unsubscribe();
    }
}
